<ng-container *ngIf="reset">
  <i class="fa fa-refresh" data-bs-toggle="tooltip" title="reset" container="ngb-modal-window" (click)="clear()"></i>
</ng-container>
<div class="dropdown open" [appOffClick]="closeDropDown">
  <span #spanField class="{{inputCssClass}}" tabindex="{{tabindex}}" autofocus appFocusNext="{{!isFilter?'span':''}}">
    <span class="suggest-select-placeholder {{inputCssClass==='form-control form-control-sm'?'pt-1':'pt-2'}} "
      [ngClass]="{'text-muted':isDisable}">
      {{selectedItem?selectedItem.name:placeholder}}</span>

    <i class="dropdown-toggle pull-right {{inputCssClass==='form-control form-control-sm'?'pt-1':'pt-2'}}"></i>
  </span>

  <div class="dropdown-container">
    <input #inputField [style.display]="isFilter?'':'none'" (keydown)="onIputKeyDown($event)"
      *ngIf="isFilter&&((!isGroup&&!!options?.length&&dropDown) || (isGroup&&!!optionsGroup?.length&&dropDown))"
      autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" type="other"
      (input)="inputChanges($event.target.value)" (minput)="inputChanges($event)" id="name" [ngClass]="inputCssClass">
    <ul *ngIf="!isGroup&&!!options?.length&&dropDown" class="dropdown-menu" role="menu">
      <li *ngFor="let o of options " role="menuitem">
        <div class="drop-down-row" [ngClass]="{'active': isActive(o)}" (mouseenter)="mouseOver(o)">
          <a #dropDownItem href="javascript:void(0)" (click)="itemSelected(o,false,true)" tabindex="-1"
            class="dropdown-item" *ngIf="!o?.hide">
            <div >{{o?.prefix}} {{o?.name}} {{o?.suffix}}</div>
          </a>
        </div>
      </li>
    </ul>

    <ul *ngIf="isGroup&&!!optionsGroup?.length&&dropDown" class="dropdown-menu" role="menu">
      <li style="font-weight: bold;" *ngFor="let o of optionsGroup" role="menuitem">
        <div class="dropdown-toolbar">{{o?.title}}</div>
        <ng-container *ngFor="let sub of o.options ">
          <div class="drop-down-row" [ngClass]="{'active': isActive(sub)}" (mouseenter)="mouseOver(sub)">
            <a #dropDownItem href="javascript:void(0)" (click)="itemSelected(sub,false,true)" tabindex="-1"
              class="dropdown-item">
              <div>{{sub?.prefix}} {{sub?.name}} {{sub?.suffix}}</div>
            </a>
          </div>
        </ng-container>
      </li>
    </ul>
    <ng-container *ngIf="dropDown&&!!addMoreTemplate">
      <ng-container *ngTemplateOutlet="addMoreTemplate"></ng-container>
    </ng-container>
  </div>
</div>